"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var table_1 = require("antd/lib/table");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionRobot_1 = require("../../../../../../../../shared/components/table_actions/TableActionRobot");
var BonusTournamentBotsList = /** @class */ (function (_super) {
    __extends(BonusTournamentBotsList, _super);
    function BonusTournamentBotsList(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentBotsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
            _this.props.state.setExtBreadCrumbPath(["Боты турнира"]);
        });
    };
    BonusTournamentBotsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BonusTournamentBotsList.prototype.doLockUnlockAction = function (Key, Title, Lock) {
        this.props.data.DoSetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u0442 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    BonusTournamentBotsList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Турнир',
                dataIndex: this.props.data.dk_key,
                key: this.props.data.dk_key,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.rootRecord.title);
                }
            }, {
                title: 'Логин',
                dataIndex: this.props.data.dk_usr_player_login,
                key: this.props.data.dk_usr_player_login,
                width: 150
            }, {
                title: 'Присоединение',
                dataIndex: this.props.data.dk_join_tournament_type_title,
                key: this.props.data.dk_join_tournament_type_title,
                width: 150
            }, {
                title: 'Игра',
                dataIndex: this.props.data.dk_gws_gameprovider_game_title,
                key: this.props.data.dk_gws_gameprovider_game_title,
                width: 150
            }, {
                title: 'Время, сек',
                dataIndex: this.props.data.dk_join_seconds_min,
                key: this.props.data.dk_join_seconds_min,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        record.join_seconds_min,
                        " : ",
                        record.join_seconds_max);
                },
                width: 150
            }, {
                title: 'Удача',
                dataIndex: this.props.data.dk_join_seconds_min,
                key: this.props.data.dk_join_seconds_min,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        record.lucky_percent_x100_min,
                        "% : ",
                        record.lucky_percent_x100_max,
                        "%");
                },
                width: 150
            }, {
                title: 'общ. приз',
                dataIndex: this.props.data.dk_bot_total_win,
                key: this.props.data.dk_bot_total_win,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        record.bot_total_win,
                        " : ",
                        React.createElement(TableActionRobot_1.default, { hint: "Сгенерировать выигрыши", onClick: function () { _this.onGenerateBotWinaClick(record); } }));
                },
                align: "right",
                width: 150
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать бот", text: "Нет" }, lockedTexts: { menu: "Заблокировать бот", text: "Да" }, record: { key: record.key, title: record.usr_player_login, locked: record.is_locked }, onLockClick: _this.doLockUnlockAction.bind(_this) }));
                },
                width: 120
            }, {
                title: 'Добавлен',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 100
            }
        ]);
    };
    BonusTournamentBotsList.prototype.onGenerateBotWinaClick = function (record) {
        this.props.data.generateWins(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0412\u044B\u0438\u0433\u0440\u044B\u0448\u0438 \u0434\u043B\u044F \u0431\u043E\u0442\u0430 \u0431\u044B\u043B\u0438 \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u044B"));
        });
    };
    BonusTournamentBotsList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BonusTournamentBotsList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTournamentBotsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BonusTournamentBotsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(table_1.default, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); } })));
    };
    return BonusTournamentBotsList;
}(React.Component));
exports.default = BonusTournamentBotsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/bots/BonusTournamentBotsList.tsx
// module id = 2524
// module chunks = 0